import React, { useState, useEffect, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import config from "./common/Config";
import { isBritWholesaleUi } from "../utils/britWholesaleUi";
import { useRole } from "../contexts/RoleContext";
import "rsuite/Dropdown/styles/index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useMediaQuery,
  useTheme,
  Menu,
  MenuItem,
  ListItemIcon,
  Typography,
  Divider
} from '@mui/material';
import { Iconify } from './Minimal/src/components/iconify/iconify';
import { removeCurrentTabFromRegistry } from "../utils/activeTabSession";
import { encryptPayload, resolveEncryptedResponse } from "../utils/customerCrypto";
import { resolveCustomerApiEncrypt, clearCompanySettingsCache } from "../utils/companySettingsCache";
import { clearUserRolesCache } from "../utils/userRolesCache";
import { useCompanySettings } from "../contexts/CompanySettingsContext";

const Header = () => {
  const {
    hasPermission,
    hasAnyPermission,
    isRole,
    activeRole,
    permissionsRevision,
  } = useRole();
  const showEposNavItem = isRole(18) || hasPermission('POS');
  const [activeLink, setActiveLink] = useState("Dashboard");
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [SiteName, setSiteName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [showNotifications, setShowNotifications] = useState(false); // Toggle notification dropdown
  const [showProfileDropdown, setShowProfileDropdown] = useState(false); // Toggle profile dropdown
  const [notificationCount, setNotificationCount] = useState(4); // Placeholder for notification count
  const [notificationData, setNotificationData] = useState([]);
  const [orderStatus, setOrderStatus] = useState(null);
  const [orderProcessSequence, setOrderProcessSequence] = useState(null);
  const accessToken = localStorage.getItem("accessToken");
  const isSinglePicking = localStorage.getItem("isSinglePicking");
  const shopifyConnectivity = localStorage.getItem("shopifyConnectivity");
  const amazonConnectivity = localStorage.getItem("amazonConnectivity");
  const showEmailTemplate = localStorage.getItem("showEmailTemplate");
  const showContraPrice = localStorage.getItem("showContraPrice");
  const userId = localStorage.getItem("userId");
  const user_role = activeRole?.id ?? localStorage.getItem("user_role");
  const token = localStorage.getItem('token');
  const prefix = localStorage.getItem('accessToken');
  const username = localStorage.getItem('username');
  const navigate = useNavigate();
  const location = useLocation();
  const { settings: companySettings } = useCompanySettings();
  // console.log(user_role);
  if (accessToken == "ayt") {
    const pageTitle = "Southall";
  }
  if (accessToken == "dds") {
    const pageTitle = "DDsnack";
  } else {
    const pageTitle = "Ebusso";
  }

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    const token = localStorage.getItem("token");

    if (!accessToken) {
      window.location.href = "/react/login";
      return;
    }

    const userId = localStorage.getItem("userId");
    const site_name = localStorage.getItem("site_name");
    const storedFirstName = localStorage.getItem("first_name");
    const storedLastName = localStorage.getItem("last_name");

    if (site_name) {
      setSiteName(site_name);
    }
    if (storedFirstName) {
      setFirstName(storedFirstName);
    }
    if (storedLastName) {
      setLastName(storedLastName);
    }
  }, []);

  useEffect(() => {
    if (!accessToken || !companySettings) {
      return;
    }
    if (companySettings.order_status !== undefined) {
      setOrderStatus(String(companySettings.order_status));
    }
    if (companySettings.order_process_sequence !== undefined) {
      setOrderProcessSequence(String(companySettings.order_process_sequence));
    }
  }, [accessToken, companySettings]);

  const handleSetActiveLink = (link) => {
    setActiveLink(link);
  };

  const handleMobileNavToggle = () => {
    setMobileNavOpen(!mobileNavOpen);
  };

  const handleLogout = () => {
    removeCurrentTabFromRegistry();
    try {
      const apiBCUrl = `${config.API_URL}/ws-logout`;
      void (async () => {
        const formData = new FormData();
        const settings = companySettings;
        const useEncrypt = resolveCustomerApiEncrypt(settings);
        if (useEncrypt) {
          const ep = encryptPayload({ Platform: "Web" });
          if (ep) {
            formData.append("encrypted_payload", ep);
          } else {
            formData.append("Platform", "Web");
          }
        } else {
          formData.append("Platform", "Web");
        }
        await fetch(apiBCUrl, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: formData,
          keepalive: true,
        });
      })();
    } catch (_) {}
    clearCompanySettingsCache();
    clearUserRolesCache();
    localStorage.removeItem("site_name");
    localStorage.removeItem("first_name");
    localStorage.removeItem("last_name");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("user_role");
    localStorage.removeItem("active_role_id");
    localStorage.removeItem("user_roles_data");
    localStorage.removeItem("role_permissions_map");
    localStorage.removeItem("user_permissions");
    localStorage.removeItem("isSinglePicking");
    localStorage.removeItem("shopifyConnectivity");
    localStorage.removeItem("amazonConnectivity");
    localStorage.removeItem("QuickBooksConnectivity");
    localStorage.removeItem("showEmailTemplate");
    localStorage.removeItem("showContraPrice");
    localStorage.removeItem("token");
    localStorage.removeItem("username");

    window.location.href = `${config.LOG_OUT}`;
  };

  // Toggle the notifications dropdown
  const toggleNotifications = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    setShowNotifications(!showNotifications);
    setShowProfileDropdown(false);
    // getNotificationData();
  };

  const getNotificationData = async () => {
    const apiBCUrl = `${config.API_URL}/ws-get-notification-data`;
    try {
      const response = await fetch(apiBCUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch notification list");
      }

      const data = await response.json();
      // console.log(data);
      setNotificationData(data.data);
    } catch (error) {
      console.log("Error fetch notification data", error);
    }
  };

  const toggleProfileDropdown = (e) => {
    e.stopPropagation();
    setShowProfileDropdown(!showProfileDropdown);
    setShowNotifications(false);
  };

  const handleClickOutside = (e) => {
    if (showNotifications && !e.target.closest(".notification-drop")) {
      setShowNotifications(false);
    }
    if (showProfileDropdown && !e.target.closest(".nav-profile")) {
      setShowProfileDropdown(false);
    }
  };

  useEffect(() => {
    // getNotificationData();
    // Close notification dropdown and profile dropdown when clicked outside
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showNotifications, showProfileDropdown]);
  const checkIfAlreadyLoggedIn = async () => {

    if (!userId || !prefix) return true; // allow if not logged in

    const checkFormData = new FormData();
    const checkPayload = {
      username,
      platform: 'Web',
    };
    if (token) {
      checkPayload.token = token;
    }
    Object.entries(checkPayload).forEach(([key, value]) => {
      checkFormData.append(key, value ?? '');
    });

    try {
      const checkResponse = await fetch(`${config.API_URL}/ws-check-if-already-logged-in`, {
        method: 'POST',
        body: checkFormData,
      });
      const rawCheckData = await checkResponse.json();
      const checkData = resolveEncryptedResponse(rawCheckData) || rawCheckData;
      // if (checkData && checkData.success === true && checkData.lastLoginData && checkData.lastLoginData.jwtTokenWeb) {
      //   // If the token in localStorage does not match the server's lastLoginData.jwtToken, force logout
      //   if (token && token !== checkData.lastLoginData.jwtTokenWeb) {
      //     //Token mismatch, show alert and logout
      //     window.localStorage.clear();
      //     window.location.href = `${config.BASE_URL}/login`;
      //     return false;
      //   }
      // }
      // If success false and message, also force logout
      // if (checkData && checkData.success === false && checkData.message) {
      //   window.localStorage.clear();
      //   window.location.href = `${config.BASE_URL}/login`;
      //   return false;
      // }
      return true;
    } catch (err) {
      // On error, allow access (or optionally force logout)
      return true;
    }
  };

  useEffect(() => {

    (async () => {
      const ok = await checkIfAlreadyLoggedIn();
      if (!ok) return;
      if (prefix) {
        localStorage.setItem("accessToken", prefix);
        localStorage.setItem("userId", userId);
        //fetchUserData();
      } else {
        window.location.href = `${config.LOG_OUT}`;
      }
    })();
  }, [prefix, userId]);
  const [anchorEls, setAnchorEls] = useState({});
  const [subMenuAnchors, setSubMenuAnchors] = useState({});

  const handleMenuOpen = (event, menuName) => {
    setAnchorEls((prev) => ({ ...prev, [menuName]: event.currentTarget }));
  };

  const handleMenuClose = (menuName) => {
    setAnchorEls((prev) => ({ ...prev, [menuName]: null }));
    setSubMenuAnchors((prev) => ({ ...prev, [menuName]: null }));
  };

  const handleSubMenuOpen = (event, parentMenu, subMenuName) => {
    event.stopPropagation();
    setSubMenuAnchors((prev) => ({ ...prev, [`${parentMenu}-${subMenuName}`]: event.currentTarget }));
  };

  const handleSubMenuClose = (parentMenu, subMenuName) => {
    setSubMenuAnchors((prev) => ({ ...prev, [`${parentMenu}-${subMenuName}`]: null }));
  };

  return (
    <header id="header" className="header fixed-top" data-scrollto-offset="0">
      <div className="container-fluid d-flex align-items-center justify-content-between">
        {isRole(18) || isRole(19) ? <>
          <span className="logo-area align-items-center scrollto me-auto me-lg-0">
            {SiteName}
          </span>
        </> : (
          <Link
            to={`/dashboard/${accessToken}/${userId}`}
            className="logo-area align-items-center scrollto me-auto me-lg-0"
          >
            {SiteName}
          </Link>
        )}
        {/* {user_role == 1 && (
          <Link
            to="/dashboard/company-settings"
            className={
              location.pathname === "/dashboard/company-settings" && "active"
            }
          >
            <span>Company Settings</span>
          </Link>
        )} */}
        {/* Dashboard menu - visible to all roles */}
        {!(isRole(18) || isRole(19) || isRole(20)) && (
          <nav
            key={`navbar-main-${permissionsRevision}`}
            id="navbar"
            className={`navbar ${mobileNavOpen ? "mobile-nav-active" : ""}`}
          >
            <ul
              className={`nav-menu ${mobileNavOpen ? "mobile-nav-show" : ""}`}
            >
              <li>
                <Link
                  to={`/dashboard/${accessToken}/${userId}`}
                  onClick={() => handleSetActiveLink("Dashboard")}
                  className={
                    location.pathname ===
                    `/dashboard/${accessToken}/${userId}` && "active"
                  }
                >
                  <span>Dashboard</span>
                </Link>
              </li>
              {/* Show menu items based on permissions */}
              {hasPermission('Company Settings') && (
                <li>
                  <Link
                    to="/dashboard/company-settings"
                    className={
                      location.pathname === "/dashboard/company-settings" && "active"
                    }
                  >
                    <span>Company Settings</span>
                  </Link>
                </li>
              )}
              {(hasPermission('Role Permission') || hasPermission('Role Permissions')) && (
                <li>
                  <Link
                    to="/settings/change_permissions/1"
                    className={
                      location.pathname.includes("/settings/change_permissions") && "active"
                    }
                  >
                    <span>Role Permissions</span>
                  </Link>
                </li>
              )}
              {(hasPermission('Role Permission') || hasPermission('Role Permissions')) && (
                <li>
                  <Link
                    to="/settings/product_form_fields"
                    className={
                      location.pathname.includes("/settings/product_form_fields") && "active"
                    }
                  >
                    <span>Product</span>
                  </Link>
                </li>
              )}
              {(hasPermission('Role Permission') || hasPermission('Role Permissions')) && (
                <li>
                  <Link
                    to="/settings/customer_form_fields"
                    className={
                      location.pathname.includes("/settings/customer_form_fields") && "active"
                    }
                  >
                    <span>Customer</span>
                  </Link>
                </li>
              )}

              {((hasAnyPermission(['NewSales', 'SalesHistory', 'SalesQuickOrder', 'HoldList']) || isRole(20)) || hasPermission('HoldList') || hasPermission('SalesHistory')) ? (
                <li>
                  <Button
                    onClick={(e) => handleMenuOpen(e, "sales")}
                    sx={{
                      color: "#fff",
                      textTransform: "none",
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.08)"
                      }
                    }}
                    endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                  >
                    Sales
                  </Button>
                  <Menu
                    anchorEl={anchorEls.sales}
                    open={Boolean(anchorEls.sales)}
                    onClose={() => handleMenuClose("sales")}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    PaperProps={{
                      sx: {
                        mt: 1,
                        minWidth: 200,
                        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                        borderRadius: 1,
                      },
                    }}
                  >
                    {(orderProcessSequence === "4" || (orderStatus === "2" && orderProcessSequence === "2")) ? (
                      <>
                        {hasPermission('HoldList') && (
                          <MenuItem
                            component={Link}
                            to="/sales/holdList"
                            onClick={() => handleMenuClose("sales")}
                            selected={location.pathname === "/sales/holdList"}
                            sx={{
                              color: location.pathname === "/sales/holdList" ? "#1976d2" : "#212b36",
                              fontWeight: location.pathname === "/sales/holdList" ? 600 : 400,
                            }}
                          >
                            Hold List
                          </MenuItem>
                        )}
                        {hasPermission('SalesHistory') && (
                          <MenuItem
                            component={Link}
                            to="/sales/shistory"
                            onClick={() => handleMenuClose("sales")}
                            selected={location.pathname === "/sales/shistory"}
                            sx={{
                              color: location.pathname === "/sales/shistory" ? "#1976d2" : "#212b36",
                              fontWeight: location.pathname === "/sales/shistory" ? 600 : 400,
                            }}
                          >
                            Order History
                          </MenuItem>
                        )}
                      </>
                    ) : (
                      <>
                        {hasPermission('NewSales') && !(orderStatus === "2" && orderProcessSequence === "1") && (
                          <MenuItem
                            component={Link}
                            to="/sales/newsales"
                            onClick={() => handleMenuClose("sales")}
                            selected={location.pathname === "/sales/newsales"}
                            sx={{
                              color: location.pathname === "/sales/newsales" ? "#1976d2" : "#212b36",
                              fontWeight: location.pathname === "/sales/newsales" ? 600 : 400,
                            }}
                          >
                            New Sales
                          </MenuItem>
                        )}
                        {hasPermission('SalesHistory') && (
                          <MenuItem
                            component={Link}
                            to="/sales/shistory"
                            onClick={() => handleMenuClose("sales")}
                            selected={location.pathname === "/sales/shistory"}
                            sx={{
                              color: location.pathname === "/sales/shistory" ? "#1976d2" : "#212b36",
                              fontWeight: location.pathname === "/sales/shistory" ? 600 : 400,
                            }}
                          >
                            Order History
                          </MenuItem>
                        )}
                        {hasPermission('HoldList') && (
                          <MenuItem
                            component={Link}
                            to="/sales/holdList"
                            onClick={() => handleMenuClose("sales")}
                            selected={location.pathname === "/sales/holdList"}
                            sx={{
                              color: location.pathname === "/sales/holdList" ? "#1976d2" : "#212b36",
                              fontWeight: location.pathname === "/sales/holdList" ? 600 : 400,
                            }}
                          >
                            Hold List
                          </MenuItem>
                        )}
                        {hasPermission('SalesHistory') && (
                          <MenuItem
                            component={Link}
                            to="/sales/reject_sales"
                            onClick={() => handleMenuClose("sales")}
                            selected={location.pathname === "/sales/reject_sales"}
                            sx={{
                              color: location.pathname === "/sales/reject_sales" ? "#1976d2" : "#212b36",
                              fontWeight: location.pathname === "/sales/reject_sales" ? 600 : 400,
                            }}
                          >
                            Reject Sales History
                          </MenuItem>
                        )}
                        {/* { config.PREFIX == "atr" && isRole(8) && (
                          <MenuItem
                            component={Link}
                            to="/sales/IncompleteOrderList"
                            onClick={() => handleMenuClose("sales")}
                            selected={location.pathname === "/sales/IncompleteOrderList"}
                            sx={{
                              color: location.pathname === "/sales/IncompleteOrderList" ? "#1976d2" : "#212b36",
                              fontWeight: location.pathname === "/sales/IncompleteOrderList" ? 600 : 400,
                            }}
                          >
                           Customer Incomplete Order
                          </MenuItem>
                        )} */}
                        {isRole(20) && (
                          <MenuItem
                            component={Link}
                            to="/sales/quick-order"
                            onClick={() => handleMenuClose("sales")}
                            selected={location.pathname === "/sales/quick-order"}
                            sx={{
                              color: location.pathname === "/sales/quick-order" ? "#1976d2" : "#212b36",
                              fontWeight: location.pathname === "/sales/quick-order" ? 600 : 400,
                            }}
                          >
                            Tele Caller
                          </MenuItem>
                        )}
                        {hasPermission('Inventory_Report') && (
                          <MenuItem
                            component={Link}
                            to="/sales/InventoryReport"
                            onClick={() => handleMenuClose("sales")}
                            selected={location.pathname === "/sales/InventoryReport"}
                            sx={{
                              color: location.pathname === "/sales/InventoryReport" ? "#1976d2" : "#212b36",
                              fontWeight: location.pathname === "/sales/InventoryReport" ? 600 : 400,
                            }}
                          >
                            Inventory Report
                          </MenuItem>
                        )}
                        {showEposNavItem && (
                          <MenuItem
                            component={Link}
                            to="/sales/epos/new"
                            onClick={() => handleMenuClose("sales")}
                            selected={location.pathname === "/sales/epos/new"}
                            sx={{
                              color: location.pathname === "/sales/epos/new" ? "#1976d2" : "#212b36",
                              fontWeight: location.pathname === "/sales/epos/new" ? 600 : 400,
                            }}
                          >
                            Epos
                          </MenuItem>
                        )}
                      </>
                    )}
                  </Menu>
                </li>
              ) : null}
              {hasAnyPermission(['CreatePicking', 'PickingList', 'PickingHistory', 'ProformaInvoice']) && orderStatus !== "3" && (
                <li>
                  <Button
                    onClick={(e) => handleMenuOpen(e, "picking")}
                    sx={{
                      color: "#fff",
                      textTransform: "none",
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.08)"
                      }
                    }}
                    endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                  >
                    Picking
                  </Button>
                  <Menu
                    anchorEl={anchorEls.picking}
                    open={Boolean(anchorEls.picking)}
                    onClose={() => handleMenuClose("picking")}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    PaperProps={{
                      sx: {
                        mt: 1,
                        minWidth: 200,
                        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                        borderRadius: 1,
                      },
                    }}
                  >
                    {/* {hasPermission('CreatePicking') && (
                      <MenuItem
                        component={Link}
                        to="/picking/picking_create"
                        onClick={() => handleMenuClose("picking")}
                        selected={location.pathname === "/picking/picking_create"}
                        sx={{
                          color: location.pathname === "/picking/picking_create" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/picking/picking_create" ? 600 : 400,
                        }}
                      >
                        Create Picking
                      </MenuItem>
                    )} */}
                    {hasPermission('PickingList') && (
                      <MenuItem
                        component={Link}
                        to={isSinglePicking === 'Y' ? "/picking/single_picking_list" : "/picking/picking_list"}
                        onClick={() => handleMenuClose("picking")}
                        selected={location.pathname === "/picking/single_picking_list" || location.pathname === "/picking/picking_list"}
                        sx={{
                          color: (location.pathname === "/picking/single_picking_list" || location.pathname === "/picking/picking_list") ? "#1976d2" : "#212b36",
                          fontWeight: (location.pathname === "/picking/single_picking_list" || location.pathname === "/picking/picking_list") ? 600 : 400,
                        }}
                      >
                        Picking List
                      </MenuItem>
                    )}
                    {/* {hasPermission('PickingHistory') && (
                      <MenuItem
                        component={Link}
                        to="/picking/picking_history"
                        onClick={() => handleMenuClose("picking")}
                        selected={location.pathname === "/picking/picking_history"}
                        sx={{
                          color: location.pathname === "/picking/picking_history" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/picking/picking_history" ? 600 : 400,
                        }}
                      >
                        Picking History
                      </MenuItem>
                    )} */}
                    {hasPermission('PickingHistory') && isSinglePicking === 'N' && (
                      <MenuItem
                        component={Link}
                        to="/picking/short_qty"
                        onClick={() => handleMenuClose("picking")}
                        selected={location.pathname === "/picking/short_qty"}
                        sx={{
                          color: location.pathname === "/picking/short_qty" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/picking/short_qty" ? 600 : 400,
                        }}
                      >
                        Short QTY
                      </MenuItem>
                    )}
                    {hasPermission('ProformaInvoice') && (
                      <MenuItem
                        component={Link}
                        to="/picking/proforma"
                        onClick={() => handleMenuClose("picking")}
                        selected={location.pathname === "/picking/proforma"}
                        sx={{
                          color: location.pathname === "/picking/proforma" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/picking/proforma" ? 600 : 400,
                        }}
                      >
                        Confirm Picking
                      </MenuItem>
                    )}
                  </Menu>
                </li>
              )}

              {hasAnyPermission(['CreateManifest', 'Trip']) && (
                <li>
                  <Button
                    onClick={(e) => handleMenuOpen(e, "delivery")}
                    sx={{
                      color: "#fff",
                      textTransform: "none",
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.08)"
                      }
                    }}
                    endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                  >
                    Dispatch & Deliveries
                  </Button>
                  <Menu
                    anchorEl={anchorEls.delivery}
                    open={Boolean(anchorEls.delivery)}
                    onClose={() => handleMenuClose("delivery")}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    PaperProps={{
                      sx: {
                        mt: 1,
                        minWidth: 200,
                        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                        borderRadius: 1,
                      },
                    }}
                  >
                    {hasPermission('CreateManifest') && (
                      <MenuItem
                        component={Link}
                        to="/delivery/route_planing"
                        onClick={() => handleMenuClose("delivery")}
                        selected={location.pathname === "/delivery/route_planing"}
                        sx={{
                          color: location.pathname === "/delivery/route_planing" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/delivery/route_planing" ? 600 : 400,
                        }}
                      >
                        Create Manifest
                      </MenuItem>
                    )}
                    {hasPermission('CreateManifest') && (
                      <MenuItem
                        component={Link}
                        to="/manifest_list"
                        onClick={() => handleMenuClose("delivery")}
                        selected={location.pathname === "/manifest_list"}
                        sx={{
                          color: location.pathname === "/manifest_list" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/manifest_list" ? 600 : 400,
                        }}
                      >
                        Manifest List
                      </MenuItem>
                    )}
                    {hasPermission('Trip') && (
                      <MenuItem
                        component={Link}
                        to="/open_trips"
                        onClick={() => handleMenuClose("delivery")}
                        selected={location.pathname === "/open_trips"}
                        sx={{
                          color: location.pathname === "/open_trips" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/open_trips" ? 600 : 400,
                        }}
                      >
                        Open Trip
                      </MenuItem>
                    )}
                    {hasPermission('Trip') && (
                      <MenuItem
                        component={Link}
                        to="/complete_trips"
                        onClick={() => handleMenuClose("delivery")}
                        selected={location.pathname === "/complete_trips"}
                        sx={{
                          color: location.pathname === "/complete_trips" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/complete_trips" ? 600 : 400,
                        }}
                      >
                        Complete Trip
                      </MenuItem>
                    )}
                  </Menu>
                </li>
              )}

              {hasAnyPermission(['Product', 'ProductsPriceVariation', 'Supplier', 'Users', 'ProductCategories', 'Brand', 'Unit', 'Customers', 'CreditFacility', 'Adjustments', 'StockTake', 'OrderProductDiscount', 'Catalogue', 'Shopify Product List', 'Amazon Product List']) && (
                <li>
                  <Button
                    onClick={(e) => handleMenuOpen(e, "product-master")}
                    sx={{
                      color: "#fff",
                      textTransform: "none",
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.08)"
                      }
                    }}
                    endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                  >
                    Master
                  </Button>
                  <Menu
                    anchorEl={anchorEls["product-master"]}
                    open={Boolean(anchorEls["product-master"])}
                    onClose={() => handleMenuClose("product-master")}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    PaperProps={{
                      sx: {
                        mt: 1,
                        minWidth: 220,
                        maxHeight: 400,
                        overflowY: 'auto',
                        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                        borderRadius: 1,
                      },
                    }}
                  >
                    {hasPermission('Product') && (
                      <MenuItem
                        component={Link}
                        to="/products"
                        onClick={() => handleMenuClose("product-master")}
                        selected={location.pathname === "/products"}
                        sx={{
                          color: location.pathname === "/products" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/products" ? 600 : 400,
                        }}
                      >
                        Products
                      </MenuItem>
                    )}
                    {hasPermission('ProductsPriceVariation') && (
                      <MenuItem
                        component={Link}
                        to="/products_price_variation"
                        onClick={() => handleMenuClose("product-master")}
                        selected={location.pathname === "/products_price_variation"}
                        sx={{
                          color: location.pathname === "/products_price_variation" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/products_price_variation" ? 600 : 400,
                        }}
                      >
                        Product Price Variation
                      </MenuItem>
                    )}
                    {hasPermission('Supplier') && (
                      <MenuItem
                        component={Link}
                        to="/supplier"
                        onClick={() => handleMenuClose("product-master")}
                        selected={location.pathname === "/supplier"}
                        sx={{
                          color: location.pathname === "/supplier" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/supplier" ? 600 : 400,
                        }}
                      >
                        Suppliers
                      </MenuItem>
                    )}
                    {hasPermission('Users') && (
                      <MenuItem
                        component={Link}
                        to="/users"
                        onClick={() => handleMenuClose("product-master")}
                        selected={location.pathname === "/users"}
                        sx={{
                          color: location.pathname === "/users" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/users" ? 600 : 400,
                        }}
                      >
                        Users
                      </MenuItem>
                    )}
                    {hasPermission('ProductCategories') && (
                      <MenuItem
                        component={Link}
                        to="/product_category"
                        onClick={() => handleMenuClose("product-master")}
                        selected={location.pathname === "/product_category"}
                        sx={{
                          color: location.pathname === "/product_category" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/product_category" ? 600 : 400,
                        }}
                      >
                        Product Categories
                      </MenuItem>
                    )}
                    {hasPermission('Brand') && (
                      <MenuItem
                        component={Link}
                        to="/Brands"
                        onClick={() => handleMenuClose("product-master")}
                        selected={location.pathname === "/Brands"}
                        sx={{
                          color: location.pathname === "/Brands" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/Brands" ? 600 : 400,
                        }}
                      >
                        Brands
                      </MenuItem>
                    )}
                    {hasPermission('Unit') && (
                      <MenuItem
                        component={Link}
                        to="/Units"
                        onClick={() => handleMenuClose("product-master")}
                        selected={location.pathname === "/Units"}
                        sx={{
                          color: location.pathname === "/Units" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/Units" ? 600 : 400,
                        }}
                      >
                        Units
                      </MenuItem>
                    )}
                    {hasPermission('Customers') && (
                      <MenuItem
                        component={Link}
                        to="/customers"
                        onClick={() => handleMenuClose("product-master")}
                        selected={location.pathname === "/customers"}
                        sx={{
                          color: location.pathname === "/customers" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/customers" ? 600 : 400,
                        }}
                      >
                        Customers
                      </MenuItem>
                    )}
                    {showContraPrice === 'Y' && (
                      <MenuItem
                        component={Link}
                        to="/ContraList"
                        onClick={() => handleMenuClose("product-master")}
                        selected={location.pathname === "/ContraList"}
                        sx={{
                          color: location.pathname === "/ContraList" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/ContraList" ? 600 : 400,
                        }}
                      >
                        Contra Price Customers
                      </MenuItem>
                    )}
                    {shopifyConnectivity === 'Y' && hasPermission('Shopify Product List') && (
                      <MenuItem
                        component={Link}
                        to="/shopifyProductList"
                        onClick={() => handleMenuClose("product-master")}
                        selected={location.pathname === "/shopifyProductList"}
                        sx={{
                          color: location.pathname === "/shopifyProductList" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/shopifyProductList" ? 600 : 400,
                        }}
                      >
                        Shopify Product List
                      </MenuItem>
                    )}
                    {amazonConnectivity === 'Y' && hasPermission('Amazon Product List') && (
                      <MenuItem
                        component={Link}
                        to="/amazonProductList"
                        onClick={() => handleMenuClose("product-master")}
                        selected={location.pathname === "/amazonProductList"}
                        sx={{
                          color: location.pathname === "/amazonProductList" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/amazonProductList" ? 600 : 400,
                        }}
                      >
                        Amazon Product List
                      </MenuItem>
                    )}
                  </Menu>
                </li>
              )}

              {hasAnyPermission(['CustomernotOrder', 'DriverReport', 'InventorySales', 'Inventory_Report', 'MISreport', 'Cross-Off', 'Sales-Rep', 'ProfitLoss']) && (
                <li>
                  <Button
                    onClick={(e) => handleMenuOpen(e, "reports")}
                    sx={{
                      color: "#fff",
                      textTransform: "none",
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.08)"
                      }
                    }}
                    endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                  >
                    Report
                  </Button>
                  <Menu
                    anchorEl={anchorEls.reports}
                    open={Boolean(anchorEls.reports)}
                    onClose={() => handleMenuClose("reports")}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    PaperProps={{
                      sx: {
                        mt: 1,
                        minWidth: 200,
                        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                        borderRadius: 1,
                      },
                    }}
                  >
                    <MenuItem
                      onMouseEnter={(e) => handleSubMenuOpen(e, "reports", "sales")}
                      sx={{
                        "&:hover": {
                          backgroundColor: "rgba(145, 158, 171, 0.08)"
                        }
                      }}
                    >
                      <ListItemText>Sales</ListItemText>
                      <Iconify icon="eva:arrow-ios-forward-fill" width={16} height={16} sx={{ ml: 1 }} />
                    </MenuItem>
                    <Menu
                      anchorEl={subMenuAnchors["reports-sales"]}
                      open={Boolean(subMenuAnchors["reports-sales"])}
                      onClose={() => handleSubMenuClose("reports", "sales")}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      PaperProps={{
                        sx: {
                          ml: 0.5,
                          minWidth: 220,
                          maxHeight: 400,
                          overflowY: 'auto',
                          boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                          borderRadius: 1,
                        },
                      }}
                    >
                      <MenuItem
                        component={Link}
                        to="/reports/sales_report"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "sales");
                        }}
                        selected={location.pathname === "/reports/sales_report"}
                        sx={{
                          color: location.pathname === "/reports/sales_report" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/sales_report" ? 600 : 400,
                        }}
                      >
                        Sales Rep Report
                      </MenuItem>
                      <MenuItem
                        component={Link}
                        to="/reports/inventory_sales_report"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "sales");
                        }}
                        selected={location.pathname === "/reports/inventory_sales_report"}
                        sx={{
                          color: location.pathname === "/reports/inventory_sales_report" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/inventory_sales_report" ? 600 : 400,
                        }}
                      >
                        Inventory Sales Report
                      </MenuItem>
                      <MenuItem
                        component={Link}
                        to="/reports/sales_product_report"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "sales");
                        }}
                        selected={location.pathname === "/reports/sales_product_report"}
                        sx={{
                          color: location.pathname === "/reports/sales_product_report" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/sales_product_report" ? 600 : 400,
                        }}
                      >
                        Sales Products Report
                      </MenuItem>
                      <MenuItem
                        component={Link}
                        to="/reports/customer_not_order_report"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "sales");
                        }}
                        selected={location.pathname === "/reports/customer_not_order_report"}
                        sx={{
                          color: location.pathname === "/reports/customer_not_order_report" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/customer_not_order_report" ? 600 : 400,
                        }}
                      >
                        Customer Not Order
                      </MenuItem>
                      <MenuItem
                        component={Link}
                        to="/reports/dsr_report"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "sales");
                        }}
                        selected={location.pathname === "/reports/dsr_report"}
                        sx={{
                          color: location.pathname === "/reports/dsr_report" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/dsr_report" ? 600 : 400,
                        }}
                      >
                        DSR Report
                      </MenuItem>
                      <MenuItem
                        component={Link}
                        to="/reports/DaySummaryReport"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "sales");
                        }}
                        selected={location.pathname === "/reports/DaySummaryReport"}
                        sx={{
                          color: location.pathname === "/reports/DaySummaryReport" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/DaySummaryReport" ? 600 : 400,
                        }}
                      >
                        Day Summary Report
                      </MenuItem>
                      <MenuItem
                        component={Link}
                        to="/reports/SalesOrderReport"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "sales");
                        }}
                        selected={location.pathname === "/reports/SalesOrderReport"}
                        sx={{
                          color: location.pathname === "/reports/SalesOrderReport" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/SalesOrderReport" ? 600 : 400,
                        }}
                      >
                        Sales Order Report
                      </MenuItem>
                      {(prefix === "eve" || prefix === "ve" || prefix === "tsc") && (
                        <>
                      <MenuItem
                        component={Link}
                        to="/reports/PushInvoiceReport"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "sales");
                        }}
                        selected={location.pathname === "/reports/PushInvoiceReport"}
                        sx={{
                          color: location.pathname === "/reports/PushInvoiceReport" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/PushInvoiceReport" ? 600 : 400,
                        }}
                      >
                        Push Invoice Report
                      </MenuItem>
                      <MenuItem
                        component={Link}
                        to="/reports/PushCreditNoteReport"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "sales");
                        }}
                        selected={location.pathname === "/reports/PushCreditNoteReport"}
                        sx={{
                          color: location.pathname === "/reports/PushCreditNoteReport" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/PushCreditNoteReport" ? 600 : 400,
                        }}
                      >
                        Push Credit Note Report
                      </MenuItem>
                      </>
                      )}
                      <MenuItem
                        component={Link}
                        to="/reports/CustomerMonthlySalesReport"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "sales");
                        }}
                        selected={location.pathname === "/reports/CustomerMonthlySalesReport"}
                        sx={{
                          color: location.pathname === "/reports/CustomerMonthlySalesReport" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/CustomerMonthlySalesReport" ? 600 : 400,
                        }}
                      >
                        Customer Monthly Sales Report
                      </MenuItem>
                    </Menu>
                    <MenuItem
                      onMouseEnter={(e) => handleSubMenuOpen(e, "reports", "account")}
                      sx={{
                        "&:hover": {
                          backgroundColor: "rgba(145, 158, 171, 0.08)"
                        }
                      }}
                    >
                      <ListItemText>Account</ListItemText>
                      <Iconify icon="eva:arrow-ios-forward-fill" width={16} height={16} sx={{ ml: 1 }} />
                    </MenuItem>
                    <Menu
                      anchorEl={subMenuAnchors["reports-account"]}
                      open={Boolean(subMenuAnchors["reports-account"])}
                      onClose={() => handleSubMenuClose("reports", "account")}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      PaperProps={{
                        sx: {
                          ml: 0.5,
                          minWidth: 220,
                          boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                          borderRadius: 1,
                        },
                      }}
                    >
                      <MenuItem
                        component={Link}
                        to="/reports/profit_loss_report"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "account");
                        }}
                        selected={location.pathname === "/reports/profit_loss_report"}
                        sx={{
                          color: location.pathname === "/reports/profit_loss_report" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/profit_loss_report" ? 600 : 400,
                        }}
                      >
                        Profit and Loss
                      </MenuItem>
                      <MenuItem
                        component={Link}
                        to="/reports/TransactionsReport"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "account");
                        }}
                        selected={location.pathname === "/reports/TransactionsReport"}
                        sx={{
                          color: location.pathname === "/reports/TransactionsReport" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/TransactionsReport" ? 600 : 400,
                        }}
                      >
                        Transaction Report
                      </MenuItem>
                      <MenuItem
                        component={Link}
                        to="/reports/mis_report"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "account");
                        }}
                        selected={location.pathname === "/reports/mis_report"}
                        sx={{
                          color: location.pathname === "/reports/mis_report" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/mis_report" ? 600 : 400,
                        }}
                      >
                        MIS Order Wise
                      </MenuItem>
                      <MenuItem
                        component={Link}
                        to="/reports/mis_product_report"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "account");
                        }}
                        selected={location.pathname === "/reports/mis_product_report"}
                        sx={{
                          color: location.pathname === "/reports/mis_product_report" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/mis_product_report" ? 600 : 400,
                        }}
                      >
                        MIS Product Wise
                      </MenuItem>
                    </Menu>
                    <MenuItem
                      onMouseEnter={(e) => handleSubMenuOpen(e, "reports", "inventory")}
                      sx={{
                        "&:hover": {
                          backgroundColor: "rgba(145, 158, 171, 0.08)"
                        }
                      }}
                    >
                      <ListItemText>Inventory</ListItemText>
                      <Iconify icon="eva:arrow-ios-forward-fill" width={16} height={16} sx={{ ml: 1 }} />
                    </MenuItem>
                    <Menu
                      anchorEl={subMenuAnchors["reports-inventory"]}
                      open={Boolean(subMenuAnchors["reports-inventory"])}
                      onClose={() => handleSubMenuClose("reports", "inventory")}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      PaperProps={{
                        sx: {
                          ml: 0.5,
                          minWidth: 220,
                          boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                          borderRadius: 1,
                        },
                      }}
                    >
                      <MenuItem
                        component={Link}
                        to="/reports/stock_report"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "inventory");
                        }}
                        selected={location.pathname === "/reports/stock_report"}
                        sx={{
                          color: location.pathname === "/reports/stock_report" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/stock_report" ? 600 : 400,
                        }}
                      >
                        Stock Report
                      </MenuItem>
                      <MenuItem
                        component={Link}
                        to="/reports/batchWise_stock_report"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "inventory");
                        }}
                        selected={location.pathname === "/reports/batchWise_stock_report"}
                        sx={{
                          color: location.pathname === "/reports/batchWise_stock_report" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/batchWise_stock_report" ? 600 : 400,
                        }}
                      >
                        Batch Wise Stock Report
                      </MenuItem>
                      {isBritWholesaleUi() && (
                        <MenuItem
                          component={Link}
                          to="/reports/brit_dual_stock"
                          onClick={() => {
                            handleMenuClose("reports");
                            handleSubMenuClose("reports", "inventory");
                          }}
                          selected={location.pathname === "/reports/brit_dual_stock"}
                          sx={{
                            color: location.pathname === "/reports/brit_dual_stock" ? "#1976d2" : "#212b36",
                            fontWeight: location.pathname === "/reports/brit_dual_stock" ? 600 : 400,
                          }}
                        >
                          Brit dual stock
                        </MenuItem>
                      )}
                      {isBritWholesaleUi() && (
                        <MenuItem
                          component={Link}
                          to="/reports/brit_stock_transfer_report"
                          onClick={() => {
                            handleMenuClose("reports");
                            handleSubMenuClose("reports", "inventory");
                          }}
                          selected={location.pathname === "/reports/brit_stock_transfer_report"}
                          sx={{
                            color: location.pathname === "/reports/brit_stock_transfer_report" ? "#1976d2" : "#212b36",
                            fontWeight: location.pathname === "/reports/brit_stock_transfer_report" ? 600 : 400,
                          }}
                        >
                          Brit stock transfer report
                        </MenuItem>
                      )}
                      <MenuItem
                        component={Link}
                        to="/reports/NewProductsTransactionReport"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "inventory");
                        }}
                        selected={location.pathname === "/reports/NewProductsTransactionReport"}
                        sx={{
                          color: location.pathname === "/reports/NewProductsTransactionReport" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/NewProductsTransactionReport" ? 600 : 400,
                        }}
                      >
                        Products Transaction Report
                      </MenuItem>
                      {hasPermission('Inventory_Report') && (
                        <MenuItem
                          component={Link}
                          to="/sales/InventoryReport"
                          onClick={() => {
                            handleMenuClose("reports");
                            handleSubMenuClose("reports", "inventory");
                          }}
                          selected={location.pathname === "/sales/InventoryReport"}
                          sx={{
                            color: location.pathname === "/sales/InventoryReport" ? "#1976d2" : "#212b36",
                            fontWeight: location.pathname === "/sales/InventoryReport" ? 600 : 400,
                          }}
                        >
                          Inventory Report
                        </MenuItem>
                      )}
                    </Menu>
                    <MenuItem
                      onMouseEnter={(e) => handleSubMenuOpen(e, "reports", "other")}
                      sx={{
                        "&:hover": {
                          backgroundColor: "rgba(145, 158, 171, 0.08)"
                        }
                      }}
                    >
                      <ListItemText>Other</ListItemText>
                      <Iconify icon="eva:arrow-ios-forward-fill" width={16} height={16} sx={{ ml: 1 }} />
                    </MenuItem>
                    <Menu
                      anchorEl={subMenuAnchors["reports-other"]}
                      open={Boolean(subMenuAnchors["reports-other"])}
                      onClose={() => handleSubMenuClose("reports", "other")}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      PaperProps={{
                        sx: {
                          ml: 0.5,
                          minWidth: 220,
                          boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                          borderRadius: 1,
                        },
                      }}
                    >
                      <MenuItem
                        component={Link}
                        to="/reports/missing_order"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "other");
                        }}
                        selected={location.pathname === "/reports/missing_order"}
                        sx={{
                          color: location.pathname === "/reports/missing_order" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/missing_order" ? 600 : 400,
                        }}
                      >
                        Cross Off Report
                      </MenuItem>
                      <MenuItem
                        component={Link}
                        to="/reports/lat_long_report"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "other");
                        }}
                        selected={location.pathname === "/reports/lat_long_report"}
                        sx={{
                          color: location.pathname === "/reports/lat_long_report" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/lat_long_report" ? 600 : 400,
                        }}
                      >
                        Order Location Report
                      </MenuItem>
                    </Menu>
                    <MenuItem
                      onMouseEnter={(e) => handleSubMenuOpen(e, "reports", "purchase")}
                      sx={{
                        "&:hover": {
                          backgroundColor: "rgba(145, 158, 171, 0.08)"
                        }
                      }}
                    >
                      <ListItemText>Purchase</ListItemText>
                      <Iconify icon="eva:arrow-ios-forward-fill" width={16} height={16} sx={{ ml: 1 }} />
                    </MenuItem>
                    <Menu
                      anchorEl={subMenuAnchors["reports-purchase"]}
                      open={Boolean(subMenuAnchors["reports-purchase"])}
                      onClose={() => handleSubMenuClose("reports", "purchase")}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      PaperProps={{
                        sx: {
                          ml: 0.5,
                          minWidth: 220,
                          boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                          borderRadius: 1,
                        },
                      }}
                    >
                      <MenuItem
                        component={Link}
                        to="/reports/PurchaseOrderReport"
                        onClick={() => {
                          handleMenuClose("reports");
                          handleSubMenuClose("reports", "purchase");
                        }}
                        selected={location.pathname === "/reports/PurchaseOrderReport"}
                        sx={{
                          color: location.pathname === "/reports/PurchaseOrderReport" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/reports/PurchaseOrderReport" ? 600 : 400,
                        }}
                      >
                        Purchase Report
                      </MenuItem>
                    </Menu>
                  </Menu>
                </li>
              )}

              {hasAnyPermission(['PurchasesOrder', 'PurchasesHistory', 'StockAdjustment']) && (
                <li>
                  <Button
                    onClick={(e) => handleMenuOpen(e, "purchases")}
                    sx={{
                      color: "#fff",
                      textTransform: "none",
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.08)"
                      }
                    }}
                    endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                  >
                    Purchases
                  </Button>
                  <Menu
                    anchorEl={anchorEls.purchases}
                    open={Boolean(anchorEls.purchases)}
                    onClose={() => handleMenuClose("purchases")}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    PaperProps={{
                      sx: {
                        mt: 1,
                        minWidth: 200,
                        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                        borderRadius: 1,
                      },
                    }}
                  >
                    {hasPermission('PurchasesOrder') && (
                      <MenuItem
                        component={Link}
                        to="/purchases/purchases_order"
                        onClick={() => handleMenuClose("purchases")}
                        selected={location.pathname === "/purchases/purchases_order"}
                        sx={{
                          color: location.pathname === "/purchases/purchases_order" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/purchases/purchases_order" ? 600 : 400,
                        }}
                      >
                        Purchases Order
                      </MenuItem>
                    )}
                    {hasPermission('PurchasesHistory') && (
                      <MenuItem
                        component={Link}
                        to="/purchases/purchases_grn"
                        onClick={() => handleMenuClose("purchases")}
                        selected={location.pathname === "/purchases/purchases_grn"}
                        sx={{
                          color: location.pathname === "/purchases/purchases_grn" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/purchases/purchases_grn" ? 600 : 400,
                        }}
                      >
                        Purchases History
                      </MenuItem>
                    )}
                    {hasPermission('StockAdjustment') && (
                      <MenuItem
                        component={Link}
                        to="/purchases/StockAdjustment"
                        onClick={() => handleMenuClose("purchases")}
                        selected={location.pathname === "/purchases/StockAdjustment"}
                        sx={{
                          color: location.pathname === "/purchases/StockAdjustment" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/purchases/StockAdjustment" ? 600 : 400,
                        }}
                      >
                        Stock Adjustment
                      </MenuItem>
                    )}
                  </Menu>
                </li>
              )}

              {hasAnyPermission(['ReceivedPayments', 'CustomerAccount', 'PaymentLedger', 'BankLedger']) && (
                <li>
                  <Button
                    onClick={(e) => handleMenuOpen(e, "account")}
                    sx={{
                      color: "#fff",
                      textTransform: "none",
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.08)"
                      }
                    }}
                    endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                  >
                    Account
                  </Button>
                  <Menu
                    anchorEl={anchorEls.account}
                    open={Boolean(anchorEls.account)}
                    onClose={() => handleMenuClose("account")}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    PaperProps={{
                      sx: {
                        mt: 1,
                        minWidth: 200,
                        maxHeight: 400,
                        overflowY: 'auto',
                        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                        borderRadius: 1,
                      },
                    }}
                  >
                    {accessToken === "dds" && (
                      <MenuItem
                        component={Link}
                        to="/account/push_sage"
                        onClick={() => handleMenuClose("account")}
                        selected={location.pathname === "/account/push_sage"}
                        sx={{
                          color: location.pathname === "/account/push_sage" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/account/push_sage" ? 600 : 400,
                        }}
                      >
                        Push to Sage
                      </MenuItem>
                    )}
                    {hasPermission('ReceivedPayments') && (
                      <MenuItem
                        component={Link}
                        to="/account/payments"
                        onClick={() => handleMenuClose("account")}
                        selected={location.pathname === "/account/payments"}
                        sx={{
                          color: location.pathname === "/account/payments" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/account/payments" ? 600 : 400,
                        }}
                      >
                        Received Payments
                      </MenuItem>
                    )}
                    {hasPermission('CustomerAccount') && (
                      <MenuItem
                        component={Link}
                        to="/account/customer_accounts"
                        onClick={() => handleMenuClose("account")}
                        selected={location.pathname === "/account/customer_accounts"}
                        sx={{
                          color: location.pathname === "/account/customer_accounts" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/account/customer_accounts" ? 600 : 400,
                        }}
                      >
                        Customer Accounts
                      </MenuItem>
                    )}
                    {(prefix === 'rhp' || prefix === 'hp') && (hasPermission('CustomerTransactionEnquiry') || hasPermission('CustomerAccount')) && (
                      <MenuItem
                        component={Link}
                        to="/account/customer_transaction_enquiry"
                        onClick={() => handleMenuClose("account")}
                        selected={location.pathname === "/account/customer_transaction_enquiry"}
                        sx={{
                          color: location.pathname === "/account/customer_transaction_enquiry" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/account/customer_transaction_enquiry" ? 600 : 400,
                        }}
                      >
                        Customer Transaction Enquiry
                      </MenuItem>
                    )}
                    <MenuItem
                      component={Link}
                      to="/account/supplier_ledger"
                      onClick={() => handleMenuClose("account")}
                      selected={location.pathname === "/account/supplier_ledger"}
                      sx={{
                        color: location.pathname === "/account/supplier_ledger" ? "#1976d2" : "#212b36",
                        fontWeight: location.pathname === "/account/supplier_ledger" ? 600 : 400,
                      }}
                    >
                      Supplier Ledger
                    </MenuItem>
                    {hasPermission('PaymentLedger') && (
                      <MenuItem
                        component={Link}
                        to="/account/payment_ladger"
                        onClick={() => handleMenuClose("account")}
                        selected={location.pathname === "/account/payment_ladger"}
                        sx={{
                          color: location.pathname === "/account/payment_ladger" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/account/payment_ladger" ? 600 : 400,
                        }}
                      >
                        Payment Ledger
                      </MenuItem>
                    )}
                    {hasPermission('PaymentLedger') && (
                      <MenuItem
                        component={Link}
                        to="/account/my_ledger"
                        onClick={() => handleMenuClose("account")}
                        selected={location.pathname === "/account/my_ledger"}
                        sx={{
                          color: location.pathname === "/account/my_ledger" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/account/my_ledger" ? 600 : 400,
                        }}
                      >
                        My Ledger
                      </MenuItem>
                    )}
                    <MenuItem
                      component={Link}
                      to="/account/product_ledger"
                      onClick={() => handleMenuClose("account")}
                      selected={location.pathname === "/account/product_ledger"}
                      sx={{
                        color: location.pathname === "/account/product_ledger" ? "#1976d2" : "#212b36",
                        fontWeight: location.pathname === "/account/product_ledger" ? 600 : 400,
                      }}
                    >
                      Product Ledger
                    </MenuItem>
                    <MenuItem
                      component={Link}
                      to="/reports/payment_collection"
                      onClick={() => handleMenuClose("account")}
                      selected={location.pathname === "/reports/payment_collection"}
                      sx={{
                        color: location.pathname === "/reports/payment_collection" ? "#1976d2" : "#212b36",
                        fontWeight: location.pathname === "/reports/payment_collection" ? 600 : 400,
                      }}
                    >
                      Payment Collected
                    </MenuItem>
                    <MenuItem
                      component={Link}
                      to="/stock_take/history"
                      onClick={() => handleMenuClose("account")}
                      selected={location.pathname === "/stock_take/history"}
                      sx={{
                        color: location.pathname === "/stock_take/history" ? "#1976d2" : "#212b36",
                        fontWeight: location.pathname === "/stock_take/history" ? 600 : 400,
                      }}
                    >
                      Stock Take
                    </MenuItem>
                  </Menu>
                </li>
              )}

              {hasPermission('ReturnList') && (
                <li>
                  <Button
                    onClick={(e) => handleMenuOpen(e, "return")}
                    sx={{
                      color: "#fff",
                      textTransform: "none",
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.08)"
                      }
                    }}
                    endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                  >
                    Return
                  </Button>
                  <Menu
                    anchorEl={anchorEls.return}
                    open={Boolean(anchorEls.return)}
                    onClose={() => handleMenuClose("return")}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    PaperProps={{
                      sx: {
                        mt: 1,
                        minWidth: 200,
                        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                        borderRadius: 1,
                      },
                    }}
                  >
                    <MenuItem
                      component={Link}
                      to="/return_list"
                      onClick={() => handleMenuClose("return")}
                      selected={location.pathname === "/return_list"}
                      sx={{
                        color: location.pathname === "/return_list" ? "#1976d2" : "#212b36",
                        fontWeight: location.pathname === "/return_list" ? 600 : 400,
                      }}
                    >
                      Return List
                    </MenuItem>
                  </Menu>
                </li>
              )}

              {hasAnyPermission(['Catalogue', 'SliderSettings', 'Promotions', 'Promotion', 'EmailTemplate']) && (
                <li>
                  <Button
                    onClick={(e) => handleMenuOpen(e, "Promotions")}
                    sx={{
                      color: "#fff",
                      textTransform: "none",
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.08)"
                      }
                    }}
                    endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                  >
                    Setting
                  </Button>
                  <Menu
                    anchorEl={anchorEls.Promotions}
                    open={Boolean(anchorEls.Promotions)}
                    onClose={() => handleMenuClose("Promotions")}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    PaperProps={{
                      sx: {
                        mt: 1,
                        minWidth: 200,
                        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                        borderRadius: 1,
                      },
                    }}
                  >
                    {hasPermission('Catalogue') && (accessToken != "eve" && accessToken != "ve" && accessToken != "ayt") && (
                      <MenuItem
                        component={Link}
                        to="/Catalogue"
                        onClick={() => handleMenuClose("Promotions")}
                        selected={location.pathname === "/Catalogue"}
                        sx={{
                          color: location.pathname === "/Catalogue" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/Catalogue" ? 600 : 400,
                        }}
                      >
                        Catalogue
                      </MenuItem>
                    )}
                    <MenuItem
                      component={Link}
                      to="/slider_settings"
                      onClick={() => handleMenuClose("Promotions")}
                      selected={location.pathname === "/slider_settings"}
                      sx={{
                        color: location.pathname === "/slider_settings" ? "#1976d2" : "#212b36",
                        fontWeight: location.pathname === "/slider_settings" ? 600 : 400,
                      }}
                    >
                      Slider Settings
                    </MenuItem>
                    <MenuItem
                      component={Link}
                      to="/Promotions/Promos"
                      onClick={() => handleMenuClose("Promotions")}
                      selected={location.pathname === "/Promotions/Promos"}
                      sx={{
                        color: location.pathname === "/Promotions/Promos" ? "#1976d2" : "#212b36",
                        fontWeight: location.pathname === "/Promotions/Promos" ? 600 : 400,
                      }}
                    >
                      Promotions
                    </MenuItem>
                    {showEmailTemplate === 'Y' && (
                      <MenuItem
                        component={Link}
                        to="/emailTemplate"
                        onClick={() => handleMenuClose("Promotions")}
                        selected={location.pathname === "/emailTemplate"}
                        sx={{
                          color: location.pathname === "/emailTemplate" ? "#1976d2" : "#212b36",
                          fontWeight: location.pathname === "/emailTemplate" ? 600 : 400,
                        }}
                      >
                        Email Template
                      </MenuItem>
                    )}
                  </Menu>
                </li>
              )}
            </ul>
            <i
              className="mobile-nav-toggle bi bi-list"
              onClick={handleMobileNavToggle}
            ></i>
          </nav>
        )}

        {isRole(19) && (
          <nav
            key={`navbar-role19-${permissionsRevision}`}
            id="navbar"
            className={`navbar ${mobileNavOpen ? "mobile-nav-active" : ""}`}
          >
            <ul
              className={`nav-menu ${mobileNavOpen ? "mobile-nav-show" : ""}`}
            >
              <li>
                <Link
                  to={`/dashboard/${accessToken}/${userId}`}
                  onClick={() => handleSetActiveLink("Dashboard")}
                  className={
                    location.pathname ===
                    `/dashboard/${accessToken}/${userId}` && "active"
                  }
                >
                  <span>Dashboard</span>
                </Link>
              </li>
              <li>
                <Link
                  to={`/sales/IncompleteOrderList`}
                  className={
                    location.pathname === `/sales/IncompleteOrderList/${accessToken}/${userId}` ||
                      location.pathname === '/sales/IncompleteOrderList'
                      ? "active"
                      : ""
                  }
                >
                  <span>{config.PREFIX === 'rhp' || accessToken === 'rhp' || accessToken === 'hp' ? 'Order List' : 'Incomplete Order List'}</span>
                </Link>
              </li>
              <li>
                <Link
                  to={`/sales/epos_sales`}
                  className={
                    location.pathname === `/sales/epos_sales/${accessToken}/${userId}` ||
                      location.pathname === '/sales/epos_sales'
                      ? "active"
                      : ""
                  }
                >
                  <span>Sales Report</span>
                </Link>
              </li>
            </ul>
          </nav>
        )}

        {isRole(18) && (
          <nav
            key={`navbar-role18-${permissionsRevision}`}
            id="navbar"
            className={`navbar ${mobileNavOpen ? "mobile-nav-active" : ""}`}
          >
            <ul
              className={`nav-menu ${mobileNavOpen ? "mobile-nav-show" : ""}`}
            >
              <li>
                <Link
                  to={`/dashboard/${accessToken}/${userId}`}
                  onClick={() => handleSetActiveLink("Dashboard")}
                  className={
                    location.pathname ===
                    `/dashboard/${accessToken}/${userId}` && "active"
                  }
                >
                  <span>Dashboard</span>
                </Link>
              </li>
              {showEposNavItem && (
                <>
                  <li>
                    <Link
                      to="/sales/epos/new"
                      className={
                        location.pathname ===
                          '/sales/epos/new' ? "active" : ""
                      }
                    >
                      <span>Epos</span>
                    </Link>
                  </li>
                  {/* <li>
                    <Link
                      to="/sales/epos/new"
                      className={
                        location.pathname ===
                          'sales/epos/new' ? "active" : ""
                      }
                    >
                      <span>New Epos</span>
                    </Link>
                  </li> */}
                </>
              )}
              {hasPermission('Promotion') && (
                <li>
                  <Link
                    to="/sales/offers/promotions"
                    className={
                      location.pathname === '/sales/offers/promotions'
                        ? "active"
                        : ""
                    }
                  >
                    <span>View All Promotions</span>
                  </Link>
                </li>
              )}
            </ul>
          </nav>
        )}

        {isRole(20) && (
          <nav
            key={`navbar-role20-${permissionsRevision}`}
            id="navbar"
            className={`navbar ${mobileNavOpen ? "mobile-nav-active" : ""}`}
          >
            <ul
              className={`nav-menu ${mobileNavOpen ? "mobile-nav-show" : ""}`}
            >
              <li>
                <Link
                  to={`/dashboard/${accessToken}/${userId}`}
                  onClick={() => handleSetActiveLink("Dashboard")}
                  className={
                    location.pathname ===
                    `/dashboard/${accessToken}/${userId}` && "active"
                  }
                >
                  <span>Dashboard</span>
                </Link>
              </li>
              {hasPermission('SalesQuickOrder') && (
                <li>
                  <Link
                    to="/sales/quick-order"
                    className={location.pathname === "/sales/quick-order" ? "active" : ""}
                  >
                    <span>Tele Caller</span>
                  </Link>
                </li>
              )}
              {hasPermission('Inventory_Report') && (
                <li>
                  <Link
                    to="/sales/InventoryReport"
                    className={location.pathname === "/sales/InventoryReport" ? "active" : ""}
                  >
                    <span>Inventory Report</span>
                  </Link>
                </li>
              )}
              {hasPermission('SalesReport') && (
                <li>
                  <Link
                    to="/sales/epos_sales"
                    className={location.pathname === "/sales/epos_sales" ? "active" : ""}
                  >
                    <span>Sales Report</span>
                  </Link>
                </li>
              )}
              {hasPermission('Promotion') && (
                <li>
                  <Link
                    to="/sales/offers/promotions"
                    className={
                      location.pathname === '/sales/offers/promotions'
                        ? "active"
                        : ""
                    }
                  >
                    <span>View All Promotions</span>
                  </Link>
                </li>
              )}
              {hasPermission('Customers') && (
                <li>
                  <a
                    href="/customers"
                    className={location.pathname === "/customers" ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      window.dispatchEvent(new CustomEvent("quickOrderOpenCustomerList"));
                      if (mobileNavOpen) {
                        handleMobileNavToggle();
                      }
                    }}
                  >
                    <span>Customer</span>
                  </a>
                </li>
              )}
            </ul>
            <i
              className="mobile-nav-toggle bi bi-list"
              onClick={handleMobileNavToggle}
            ></i>
          </nav>
        )}

        <div className="header-nav ms-auto">
          <ul className="d-flex align-items-center">
            {/*   <li className="nav-item dropdown">
              <a
                className={`nav-link nav-icon ${showNotifications ? "active" : ""
                  }`}
                onClick={toggleNotifications}
              >
                <i class="bi bi-bell"></i>
                <span class="badge bg-primary badge-number">
                  {notificationData?.length}
                </span>
              </a>
              <ul class="notification-drop notie">
                <li>
                
                  {showNotifications && (
                    <div
                      style={{ height: "300px", overflowY: "scroll" }}
                      id="style-3"
                    >
                      <ul className="dropdown notification-list">
                        {notificationData.map((item, index) => {
                          if (item.status === "expirePromo") {
                            const formattedDate = new Date(
                              item.expDate
                            ).toLocaleDateString("en-GB");
                            return (
                              <li key={index}>
                                <div className="notidetail">
                                  <div>
                                    <i className="bi bi-exclamation-circle text-warning"></i>
                                  </div>
                                  <div className="notdiscription">
                                    <p>Promotion expired</p>
                                    <h4>{item.productName}</h4>
                                    <p>{formattedDate}</p>
                                  </div>
                                </div>
                              </li>
                            );
                          } else {
                            return (
                              <li key={index}>
                                <div className="notidetail">
                                  <div>
                                    <i className="bi bi-exclamation-circle text-warning"></i>
                                  </div>
                                  <div className="notdiscription">
                                    <p>Product is below minimum quantity</p>
                                    <h4>{item.productName}</h4>
                                    <p className="currectstk">
                                      Current Stock : {parseInt(item.qty)}
                                    </p>
                                  </div>
                                </div>
                              </li>
                            );
                          }
                        })}
                      </ul>
                    </div>
                  )}
                </li>
              </ul>
            </li>  */}

            <li>
              <Button
                onClick={(e) => handleMenuOpen(e, "profile")}
                sx={{
                  color: "#fff",
                  textTransform: "none",
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.08)"
                  }
                }}
              >
                {firstName} {lastName ? lastName : ""}
              </Button>
              <Menu
                anchorEl={anchorEls.profile}
                open={Boolean(anchorEls.profile)}
                onClose={() => handleMenuClose("profile")}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                PaperProps={{
                  sx: {
                    mt: 1,
                    minWidth: 180,
                    boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                    borderRadius: 1,
                  },
                }}
              >
                <MenuItem
                  onClick={() => {
                    handleMenuClose("profile");
                    handleLogout();
                  }}
                  sx={{
                    color: "#212b36",
                    "&:hover": {
                      backgroundColor: "rgba(145, 158, 171, 0.08)"
                    }
                  }}
                >
                  <ListItemIcon>
                    <Iconify icon="eva:log-out-fill" width={20} height={20} sx={{ color: "#637381" }} />
                  </ListItemIcon>
                  <ListItemText>Sign Out</ListItemText>
                </MenuItem>
              </Menu>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
